module.exports = __webpack_public_path__ + "img/replay_ghosts.16ff695b.png";